/*
  Collection cards: when a color swatch is clicked on a product where only some
  colors are marked down, show that color's price and Sale badge.
  Prices come from data-color-prices on .price (snippets/price.liquid);
  badges are marked with data-card-sale-badge (snippets/card-product.liquid).
*/
(function () {
  if (window.__cardSwatchPrice) return;
  window.__cardSwatchPrice = true;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.option_circles[data-product-image]');
    if (!swatch) return;
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    var priceEl = card.querySelector('.price[data-color-prices]');
    if (!priceEl) return;

    var prices;
    try { prices = JSON.parse(priceEl.getAttribute('data-color-prices')); } catch (err) { return; }
    var d = prices[swatch.getAttribute('data-product-image')];
    if (!d) return;

    priceEl.classList.toggle('price--on-sale', d.s);
    priceEl.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (p) {
      p.textContent = d.p;
    });
    var strike = priceEl.querySelector('.price__sale s');
    if (strike) strike.textContent = d.c;

    card.querySelectorAll('[data-card-sale-badge]').forEach(function (b) {
      b.classList.toggle('hidden', !d.s);
      b.classList.toggle('block', d.s);
    });
  });
})();
